import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { msg } from 'api';
import { cannotBeBlankOrWhitespace } from 'utils/validators';

import { Form, FormSelect, FormTextarea, FormButton } from 'widgets/Form';

export default class FeedbackForm extends PureComponent {
  static propTypes = {
    feedbackOptions: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })).isRequired,
    getFeedbackOptions: PropTypes.func.isRequired,
    handleFormSubmit: PropTypes.func.isRequired,
    hasError: PropTypes.bool.isRequired,
  };

  componentDidMount() {
    const { getFeedbackOptions } = this.props;

    getFeedbackOptions();
  }

  render() {
    const {
      feedbackOptions,
      handleFormSubmit,
      hasError,
    } = this.props;

    return (
      <Form
        className="gn-content"
        onSubmit={handleFormSubmit}
      >
        <FormSelect
          name="issueType"
          className="fp-feedbackPopup__issueSelect"
          label={msg.feedbackPopup.fieldCategoryLabel}
          required
          options={feedbackOptions}
          validators={[
            { validator: cannotBeBlankOrWhitespace, message: 'This field is required.' },
          ]}
        />
        <FormTextarea
          name="feedbackComments"
          type="text"
          id="fp-feedbackPopup__fieldMessage"
          className="fp-feedbackPopup__formTextarea"
          label={msg.feedbackPopup.fieldMessageLabel}
          maxLength="1000"
          required
          validators={[
            { validator: cannotBeBlankOrWhitespace, message: 'This field is required.' },
          ]}
        />
        <FormButton>
          {msg.feedbackPopup.btnSubmit}
        </FormButton>

        {hasError && (
          <span className="fp-feedbackPopup__errorMessage">
            Something went wrong. Please try again.
          </span>
        )}
      </Form>
    );
  }
}
